import request from '@/utils/request'
// 获取案件详情(get)
export function getVehileModelList(para){
    return request({
        url:'/vehicleconfig/vehiclemodel/list/',
        method:'post',
        data:para
    })
}